import React, { useState, useEffect, useRef } from "react";
import EditUploadedDocumentPopup from "../../../Popups/EditUploadedDocument";
import DocumentsTable from "../../../Tables/DocumentsTable";
import { IDocumentModel } from "../../../Common/types";
import usePostAddLotDocument from "../../../Api/usePostAddLotDocument";
import usePostAddDocument from "../../../Api/usePostAddDocument";
import usePostRemoveLotDocument from "../../../Api/usePostRemoveLotDocument";
import Loading from "../../../Ui/Loading";
import { useAddDocument, useLinkDocToLot, useUnLinkDocToLot } from "../../../Api/Documents";
import { TableMode } from "../../../enums/TableTypes";
import AccountInfo from "../../../Profile/AccountInfo";
import { GetLotDocuments } from "./remote";

type Props = {
    documents: IDocumentModel[];
    getDocuments: () => any;
    lotId: number | string;
};

const TradeDocuments = ({ documents, getDocuments, lotId}: Props) => {
    const addDoc = useAddDocument();
    const linkDoc = useLinkDocToLot();
    const unLinkDoc = useUnLinkDocToLot();
    const [localDocuments, setLocalDocuments] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const activeUnLinkDoc = useRef("");

    // Синхронизация локального состояния с пропсом documents
    useEffect(() => {
        console.log("documents", documents);
        setLocalDocuments(documents || []);
    }, [documents]);

    const handleUnLink = async (data: string) => {
        setIsLoading(true);
        try {
            const res = await unLinkDoc.mutateAsync({ documentId: data, lotId: lotId })

            setLocalDocuments(prev => prev.filter(i => i.Id != data))
            setIsLoading(false);
            console.log(res);
        } catch (err) {
            console.log(err);
            setIsLoading(false);
        }
    }

    const handleDocument = async (data) => {
        if (data.Id) {
            try {
                linkDoc.mutate({documentId: data.Id, lotId: lotId.toString()});
                setLocalDocuments(prev => ([...prev, data]));
                console.log("full updating localDocuments", localDocuments);
            } catch (err) {
                console.log(err);
            }
        } else {
            try {
                const res = await addDoc.mutateAsync(data);

                if (res.UpdatedItem) {
                    console.log("res.UpdatedItem", res.UpdatedItem);
                    console.log("res", res);
                    linkDoc.mutate({ documentId: res.UpdatedItem.docId, lotId: lotId.toString() });
                    setLocalDocuments(prev => ([
                        ...prev,
                        {
                            Id: res.UpdatedItem.docId,
                            Name: data.Name,
                            DocumentTypeId: data.DocumentTypeId,
                            Comment: data.Comment,
                            AccountName: AccountInfo.Fio, 
                            MimeType: data.File?.type,
                            DocumentLink: res.UpdatedItem?.DocumentLink || "", 
                        },
                    ]));
                    console.log("partial updating localDocuments", localDocuments);
                } else {
                    console.log(res);
                }
            } catch (err) {
                console.log(err);
            }
        }
    };

    const updateDocuments = () => {
        GetLotDocuments(lotId).then((result) => {
            console.log("result updatedDocuments", result);
            setLocalDocuments(result.UpdatedItem);
        });
    }

    return (
        <>
            {isLoading && <Loading />}
            <button className="defaultSmallPinkButton"
                style={{
                    marginRight: "10px",
                }}
                onClick={() => updateDocuments()}>Обновить</button>

            <EditUploadedDocumentPopup
                handleDocument={handleDocument}
                updateDocuments={() => {  }}
                CanUploadFromAllDocs={true}
                MaxSizeFile={5}
                isLoading={linkDoc.isPending}
                isError={linkDoc.isError}
                isSuccess={linkDoc.isSuccess}
                error={linkDoc.error}
            />

            <DocumentsTable
                data={localDocuments?.length ? localDocuments : []}
                onRemove={handleUnLink}
                Mode={TableMode.Edit}
                isNoLocalRemove={true}
            />
        </>
    );
};

export default TradeDocuments;